import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { savingsEndpoints } from "@/features/savings/api/endpoints";
import type {
  SavingsVaultDto,
  SavingsVaultFilter,
} from "@/features/savings/api/dto";

/**
 * Liste paginée des coffres d'épargne (`POST /SavingsVaults/all` — les
 * listes sont en POST, guide §4.2). Un client ne voit que ses coffres ; le
 * back-office voit tout et peut filtrer par `ownerKeycloakUserId`.
 * Lecture authentifiée : `mutateData` en queryFn, la requête reste une
 * query TanStack (cache, invalidation).
 */
export const useSavingsVaults = (
  params: ListRequest<SavingsVaultFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.SAVINGS_VAULTS_LIST(params),
    queryFn: () =>
      mutateData({
        url: savingsEndpoints.savingsVaults.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<SavingsVaultDto>>,
    enabled,
  });
